export const COURSE_CLOSE_DATE_MIN = "2000-01-01";
export const COURSE_CLOSE_DATE_MAX = "2100-12-31";

export const COURSE_CLOSE_DATE_ERROR =
  "La fecha de cierre debe estar entre el año 2000 y el 2100.";

/**
 * Empty is allowed. Rejects 5-digit years and dates outside 2000–2100.
 * @param {unknown} value
 * @returns {string | null}
 */
export function getCourseCloseDateError(value) {
  const trimmed = typeof value === "string" ? value.trim() : "";
  if (!trimmed) {
    return null;
  }
  if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    return COURSE_CLOSE_DATE_ERROR;
  }

  const [year, month, day] = trimmed.split("-").map(Number);
  const parsed = new Date(year, month - 1, day);
  const invalidCalendar =
    parsed.getFullYear() !== year
    || parsed.getMonth() !== month - 1
    || parsed.getDate() !== day;

  if (invalidCalendar || trimmed < COURSE_CLOSE_DATE_MIN || trimmed > COURSE_CLOSE_DATE_MAX) {
    return COURSE_CLOSE_DATE_ERROR;
  }

  return null;
}
